// extracted by mini-css-extract-plugin
export default {"stickyContainer":"Notes_stickyContainer__7rEU3"};